import PropTypes from "prop-types"
import React, { useEffect, useState, FC } from "react"
import { Helmet } from "react-helmet-async";
import Input from "shared/Input/Input";
import { Link } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import api from "constants/api"
import { fetchApiJSON } from "helpers/api"
import withRouter from "components/Common/withRouter"
import { useParams } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { getData, loginCustomer } from "store/AppMaster/actions"
import { useLocation } from "react-router-dom";
import { useFormik, Formik } from "formik"
import * as Yup from "yup"
import toastr from "toastr";

export interface PageLoginProps {
  className?: string;
  props?: any;
}


const PageLogin: FC<PageLoginProps> = ({ className = "", props }) => {

  const location = useLocation();
  const sessionMessage = location.state?.sessionMessage;
  const dispatch = useDispatch();
  const [color, setColor] = useState("#2A3491");
  const [isOtpSent, setIsOtpSent] = useState(false);

  // Show toastr if sessionMessage exists
  useEffect(() => {
    if (sessionMessage) {
      toastr.error(sessionMessage);
    }
  }, [sessionMessage]);

  // Form validation
  const validation = useFormik({
    initialValues: {
      email: "",
      otp: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Must be a valid Email")
        .max(255)
        .required("Email is required"),
      otp: isOtpSent ? Yup.string().required("Please Enter OTP") : Yup.string(),
    }),
    onSubmit: async (values) => {
      if (!isOtpSent) {
        // Step 1: Send OTP
        try {
          const url = process.env.REACT_APP_API_URL + api.sendLoginOtp;
          const response = await fetchApiJSON(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ email: values.email }),
          });

          if (response.statusCode === 200) {
            setIsOtpSent(true);
            toastr.success(response.message || "OTP sent successfully.");
          } else {
            toastr.error(response.message || "Failed to send OTP.");
          }
        } catch (error) {
          toastr.error("An error occurred while sending OTP.");
          console.error(error);
        }
      } else {
        // Step 2: Verify OTP and Login
        const loginData = {
          email: values.email,
          otp: values.otp
        }
        dispatch(loginCustomer(loginData, '', api.verifyLoginOtp))
        validation.resetForm()
      }
    },
  })

  return (
    <div className={`nc-PageLogin ${className}`} data-nc-id="PageLogin">
      <Helmet>
        <title>Login | Vijaydeep</title>
      </Helmet>
      <div className="container mb-24 lg:mb-32">
        <h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
          Login
        </h2>
        <div className="max-w-md mx-auto space-y-6">
          {/* FORM */}
          <form className="grid grid-cols-1 gap-6"
            onSubmit={e => {
              e.preventDefault()
              validation.handleSubmit()
              return false
            }}
          >
            <label className="block">
              <span className="text-neutral-800 dark:text-neutral-200">
                Email address
              </span>
              <Input
                type="email"
                name="email"
                placeholder=""
                className="mt-1"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.email || ""}
                // disabled={isOtpSent}
              />
              {validation.errors.email ? (
                <small className="text-rose-600">{validation.errors.email}</small>
              ) : null}
            </label>
            {isOtpSent && (
              <label className="block">
                <span className="flex justify-between items-center text-neutral-800 dark:text-neutral-200">
                  OTP
                </span>
                <Input type="text" className="mt-1"
                  name="otp"
                  value={
                    validation.values.otp || ""
                  }
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                />
                {validation.errors.otp ? (
                  <small className="text-rose-600">{validation.errors.otp}</small>
                ) : null}
              </label>
            )}
            <ButtonPrimary type="submit">{isOtpSent ? "Verify & Login" : "Send OTP"}</ButtonPrimary>
          </form>

          {/* ==== */}
          <span className="block text-center text-neutral-700 dark:text-neutral-300">
            New user? {` `}
            <Link className="text-primary-600" to="/signup">
              Create an account
            </Link>
          </span>
        </div>
      </div>
    </div>
  );
};

export default withRouter(PageLogin);